module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/034-china-c7baf8c6b591deadac0f06313086c18d.svg";